import $ from 'jquery';

var showMenuTimeout = null;
var mouseEnterTime = null;
var $pages = $('.navigation__page--has-children.navigation__page--level1');


function isMobile() {
    return $(window).width() < 1280;
}

function equalizeLevel2Links($page) {
    var rows = {};

    $page.find('.navigation__link--level2').css('min-height', '').each(function () {
        var top = Math.round(this.getBoundingClientRect().top);
        rows[top] = (rows[top] || $()).add(this);
    });

    $.each(rows, function (top, $row) {
        $row.css('min-height', Math.max.apply(null, $row.map(function () {
            return this.offsetHeight;
        }).get()));
    });
}


$('.navigation__link-toggle').on('click', function (ev) {
    ev.preventDefault();
    var $page = $(this).closest('.navigation__page');
    $page.find('.navigation__sublist-wrap').css('max-width', '');
    $page.find('.navigation__link--level2').css('min-height', '');
    if ($page.hasClass('navigation__page--active')) {
        $pages.removeClass('navigation__page--active');
    } else {
        $pages.removeClass('navigation__page--active');
        $page.addClass('navigation__page--active');
    }
});


$pages.on('mouseenter', function (ev) {
    if (isMobile()) return;

    var $self = $(this);
    var $subpageWrap = $self.find('.navigation__subpage-wrap');
    var $sublistWrap = $self.find('.navigation__sublist-wrap');

    $sublistWrap.css('max-width', document.documentElement.clientWidth - this.getBoundingClientRect().left);

    mouseEnterTime = ev.timeStamp;
    showMenuTimeout = window.setTimeout(function () {
        showMenuTimeout = null;

        $pages.removeClass('navigation__page--active');
        $pages.find('.navigation__subpage-wrap').removeClass('navigation__subpage-wrap--visible');

        $self.addClass('navigation__page--active');
        equalizeLevel2Links($self);
        window.setTimeout(function () {
            $subpageWrap.addClass('navigation__subpage-wrap--visible');
        }, 10);
    }, 100);
}).on('mouseleave', function (ev) {
    if (isMobile()) return;

    mouseEnterTime = null;
    if (showMenuTimeout !== null) {
        window.clearTimeout(showMenuTimeout);
        showMenuTimeout = null;
    }

    var $self = $(this);
    var $subpageWrap = $self.find('.navigation__subpage-wrap');

    $subpageWrap.removeClass('navigation__subpage-wrap--visible');
    window.setTimeout(function () {
        $self.removeClass('navigation__page--active');
    }, 200);
}).on('click', function (ev) {
    if (isMobile()) return;

    if (mouseEnterTime !== null && ev.timeStamp - mouseEnterTime < 50) {
        ev.preventDefault();
        mouseEnterTime = null;
    }
});
